import React, { useState, useEffect } from "react";
import { useSelector,useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import Chart from "react-apexcharts";
import axios from "axios";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";

import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import {
  getTradesData,
  getTradesFromDatabase,
  setReportsLoading,
  setReportsLoadingFinished,
  setTradesLoading,
  setTradesLoadingFinished,
} from "../../actions/tradesActions";

import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Fade from "@mui/material/Fade";

import Spinner from "../common/Spinner";
import { faIR } from "@mui/x-data-grid";
import { type } from "@testing-library/user-event/dist/type";
import { LineWeight } from "@mui/icons-material";
import { GET_TRADES } from "../../actions/types";
import PopupPortal from "./PopupPortal";
import { abrirPopup } from "./popupController";
import ApexCharts from "apexcharts";
import { useUI } from "../context/UIContext";
const formatoCOP = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0
});
const formato = (v) =>
  v ? `COP ${Number(v).toLocaleString('es-CO')}` : 'COP 0';

function buildDetalleHTML({ w, series, dataPointIndex, detalleGastos }) {
  let html = `<div class="tooltip-gastos" style="padding:10px 12px; min-width:280px">`;

  const mes = w.globals.labels?.[dataPointIndex] ?? `Mes ${dataPointIndex + 1}`;
  //html += `<div style="font-weight:600; margin-bottom:8px">${mes}</div>`;

  const detalleMes = detalleGastos?.[dataPointIndex] || {};

  const detallesHTML = Object.entries(detalleMes)
    .filter(([k, v]) => Number(v) > 0)
    .map(([key, value]) => `
      <div style="display:flex; justify-content:space-between; gap:12px">
        <span>${key.replaceAll('_', ' ')}</span>
        <b>${formato(value)}</b>
      </div>
    `)
    .join('');

  html += detallesHTML || `<i style="opacity:.7"></i>`;
  html += `</div>`;

  return html;
}

function renderMiniChart(series, dataPointIndex, detalle) {
  const el = document.querySelector("#miniChart");
  if (!el) return;

  const detalleMes = detalle?.[dataPointIndex] || {};

  // 👇 AQUÍ va tu bloque (Top 8 subcuentas)
  const entries = Object.entries(detalleMes)
    .map(([k, v]) => [k, Number(v) || 0])
    .filter(([, v]) => v > 0)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10);   // ⬅️ top 8

  const categorias = entries.map(([k]) => k.replaceAll('_', ' '));
  const data = entries.map(([, v]) => v);

  const options = {
  chart: {
    type: "bar",
    height: 360,
    toolbar: { show: false }
  },
  plotOptions: {
    bar: {
      horizontal: true,
      barHeight: "60%",
      borderRadius: 6
    }
  },
  series: [{ name: "Gastos", data }],
  xaxis: {
    labels: {
      show: false   // ⬅️ ocultamos labels del eje para que no se monten
    }
  },
  yaxis: {
    labels: {
      show: false   // ⬅️ ocultamos categorías en el eje
    }
  },
  tooltip: {
    fixed: {
    enabled: true,
    position: "center",   // 👈 centro del chart
    offsetX: 0,
    offsetY: 0
  },
    shared: false,
    intersect: true,
    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      const categoria = categorias[dataPointIndex]; // nombre de subcuenta
      const valor = series[seriesIndex][dataPointIndex];
      return `
        <div style="padding:8px 10px; min-width:200px">
          <div style="font-weight:600; margin-bottom:4px">${categoria}</div>
          <div>Valor: <b>COP ${Number(valor).toLocaleString('es-CO')}</b></div>
        </div>
      `;
    }
  }
};



  new ApexCharts(el, options).render();
}




function arrayFilter(array, max) {
  let newArray = [];
  for (let i = 0; i < array.length - 2; i += array.length / max) {
    newArray.push(array[parseInt(i)]);
  }
  newArray.push(array[array.length - 1]);
  return newArray;
}

export default function ReportsOverviewInventory({ selected, filters }) {
  const expired = useSelector((store) => store.auth.user.expired);
  const userId = useSelector((store) => store.auth.user.public_id);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const loading_reports = useSelector((store) => store.trades.loading_reports);


  useEffect(() => {
    if (expired) {
      navigate("/profile/account_plan");
      enqueueSnackbar("Your Account is Expired", {
        variant: "error",
      });
    }
  }, [expired, navigate, enqueueSnackbar]);

  const [EstadoData, setEstadoData] = useState(true);
  const [EstadoAnual, setEstadoAnual] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [totalVentas, setTotalVentas] = useState();
  const [totalCostos, setTotalCostos] = useState();
  const [totalGastos, setTotalGastos] = useState();
  const [totalEbitda, setTotalEbitda] = useState();
  const [textoAño, setTextoAño] = useState('');
  const [ventasArea, setventasArea] = useState();
  const [costosArea, setcostosArea] = useState();
  const [gastosArea, setgastosArea] = useState();
  const [ChartDataProductos,setChartDataProductos]= useState();
  const [ChartDataVendedores,setChartDataVendedores]= useState();
  const [ChartDataCentroCostos,setChartDataCentroCostos]= useState();
  const [ChartDataVentasPorResponsable,setChartDataVentasPorResponsable]= useState();
  const [ChartDataAsesores,setChartDataAsesores]= useState();
  const [RegionVentas,setRegionVentas]= useState({});
  const [cobrosArea, setcobrosArea] = useState();
  const [pagosArea, setpagosArea] = useState();
  const [inventarioArea, setinventarioArea] = useState();
  const [liquidezArea, setliquidezArea] = useState();
  const [pruebaacida, setpruebaacidaArea] = useState();
  const [capitaltrabajo, setcapitaltrabajoArea] = useState();
  const [endeudamientoArea, setendeudamientoArea] = useState();
  const [apalancamientoArea, setapalancamientoArea] = useState();
  const [Productos,setProductos]= useState({});
  const [Vendedores,setVendedores]= useState({});
  const location = useLocation();

  const { tabValue } = useUI();

  const trades = useSelector((store) => store.trades);

  const toMoney = value => {
    const money = Number(value);
    if (isNaN(money)) {
      return value;
    }

    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0  }).format(Math.floor(money))
  }

 

 
  const [optionColumnChart, setOptionColumnChart] = useState({
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "80%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: {},
  });

  const [ejemploTortaChart1, setEjemploTortaChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  })

  
  
  const [ejemploChart1, setejemploChart] = useState({
    name: "",
    color: "#00E396",
    data: [],
  })
  
  const [ejemploOptionChart1, setEjemploOptionColumnChart] = useState({
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "30%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: {},
  });


 


  const [ejemploChart2, setejemploChart2] = useState({
    name: "",
    color: "#00E396",
    data: [],
  
  })
  
  const [ejemploOptionChart2, setEjemploOptionColumnChart2] = useState({
  series:[],
  options:{
    chart: {
      type: "bar",
      height: 500,
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "30%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: { categories: ['enero-marzo', 'marzo-junio', 'junio-septiembre', 'septiembre-diciembre']},
  }
  });



  const [ejemploOptionChart4, setEjemploOptionColumnChart4] = useState({
    series:[],
    options:{
      chart: {
        type: "bar",
        stacked: true,
        height: 350,
      },
      plotOptions: {
        bar: {
          colors: {
            ranges: [
              {
                from: -100,
                to: -46,
                color: "#F15B46",
              },
              {
                from: -45,
                to: 0,
                color: "#FEB019",
              },
            ],
          },       
          horizontal: false,
          borderRadius: 0,
          borderRadiusApplication: 'around',
          borderRadiusWhenStacked: 'last',
          columnWidth: '70%',
          barHeight: '200%',
          distributed: false,
          rangeBarOverlap: true,
          rangeBarGroupRows: false,
          hideZeroBarsWhenGrouped: false,
          isDumbbell: false,
          dumbbellColors: undefined,
          isFunnel: false,
          isFunnel3d: true
        },
      },
      dataLabels: {
        enabled: false,
                formatter: function (val) {
                  return val + "%";
                },
                offsetY: -50,
                style: {
                  fontSize: '12px',
                  colors: ["#304758"]
                }
      },
      yaxis: {
        labels: {
          formatter: function (y) {
            return y.toFixed(2);
          },
        },
      },
      xaxis: { categories: ['eseero-marzo', 'marzo-junio', 'junio-septiembre', 'septiembre-diciembre']},
    }
    });



    const [ejemplolinea, setejemplolinea] = useState({
      
       options : {
        series: [
      ],
        chart: {
        height: 350,
        stacked: true,
        type: 'line',
        toolbar: {
          show: false,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
      },
    },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth',
        width: [1, 1, 4]
      },
      grid: {
        show:false,
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        },
      },
      markers: {
        size: 1
      },
      title: {
        text: 'Evolución ingresos vs costos',
        //offsetX: 110
      },
      xaxis: {
        categories: [2021, 2022, 2023, 2024],
      },
      yaxis: [
        {
          min: 0,
          max: 800000000,
          seriesName: 'Income',
          title: {
            text: '',
          },
        },
        {
          min: 0,
          max: 800000000,
          seriesName: 'Cashflow',
          labels: {
            show: false,
          },
          opposite: true,
          axisTicks: {
            show: false,
          },
        },
        {
          min: 0,
          max: 50,
          seriesName: 'Revenue',
          labels: {
            show: true,
          },
          opposite: true,
          title: {
            text: '',
          },
        },
       
      ],
      tooltip: {
        fixed: {
          enabled: true,
          position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
          offsetY: 30,
          offsetX: 60
        },
        y: [{
          formatter: function (y) {
            if(typeof y !== "undefined") {
              return  y.toFixed(0) + "$";
            }
            return y;
            
          }
        }, {
          formatter: function (y) {
            if(typeof y !== "undefined") {
              return  y.toFixed(2) + "$";
            }
            return y;
            
          }},
          {
            formatter: function (y) {
              if(typeof y !== "undefined") {
                return  y.toFixed(4) + "%";
              }
              return y;
              
            }
        }]
      },
      legend: {
        horizontalAlign: 'left',
        offsetX: 40
      }
      }

     
    
    
      });




      const [ejemplolinea2, setejemplolinea2] = useState({
      
        options : {
         series: [
       ],
         chart: {
         height: 350,
         stacked: true,
         type: 'line',
         toolbar: {
          show: false,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
       },
      },
       dataLabels: {
         enabled: false
       },
       stroke: {
         curve: 'smooth',
         width: [1, 1, 1,4]
       },
       plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            total: {
              enabled: false,
              offsetX: 0,
              style: {
                fontSize: '13px',
                fontWeight: 900
              }
            }
          }
        },
      },
       grid: {
         show:false,
         borderColor: '#e7e7e7',
         row: {
           colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
           opacity: 0.5
         },
       },
       markers: {
        size: 1
      },
       title: {
         text: 'Gastos admon y ventas',
         //offsetX: 110
       },
       xaxis: {
         categories: [2021, 2022, 2023, 2024],
       },
       yaxis: [
         {
          min: 0,
          max: 800000000,
           seriesName: 'ventas',
           title: {
             text: '',
           },
         },
         {
          min: 0,
          max: 800000000,
           seriesName: 'Gastos administracion',
           labels: {
             show: false,
           },
           opposite: false,
           axisTicks: {
             show: false,
           },
         },

         {
          min: 0,
          max: 800000000,
          seriesName: 'Gastos ventas',
          labels: {
            show: false,
          },
          opposite: true,
          axisTicks: {
            show: false,
          },
        },
        {
          min: 0,
          max: 50,
          seriesName: 'Revenue',
          labels: {
            show: true,
          },
          opposite: true,
          title: {
            text: '',
          },
        },
      
        
       ],
       tooltip: {
         fixed: {
           enabled: true,
           position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
           offsetY: 30,
           offsetX: 60
         },
         y: [{
           formatter: function (y) {
             if(typeof y !== "undefined") {
               return  y.toFixed(0) + "$";
             }
             return y;
             
           }
         }, {
           formatter: function (y) {
             if(typeof y !== "undefined") {
               return  y.toFixed(2) + "$";
             }
             return y;
             
           }},
           {
             formatter: function (y) {
               if(typeof y !== "undefined") {
                 return  y.toFixed(4) + "%";
               }
               return y;
               
             }
         }]
       },
       legend: {
         horizontalAlign: 'left',
         offsetX: 40
       }
       }
 
      
     
     
       });




      const [lineaMargen, setlineaMargen] = useState({
     
        options: {
          series: [
          ],
          chart: {
            height: 350,
            type: 'line',
            dropShadow: {
              enabled: true,
              color: '#000',
              top: 18,
              left: 7,
              blur: 10,
              opacity: 0.2
            },
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false
            }
          },
          colors: ['#77B6EA', '#545454'],
          dataLabels: {
            enabled: false, 
            align: 'left',
           
          offsetX: 7,
          offsetY: 0,    
            formatter: function(val, opt) {
              return val.toFixed(0) + "%";
          },
          },
          stroke: {
            curve: 'smooth'
          },
          title: {
            text: 'Margenes',
            align: 'left'
          },
          grid: {
            show:false,
            borderColor: '#e7e7e7',
            align: 'left',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          markers: {
            size: 1
          },
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  return  y.toFixed(0) + "%";
                }
                return y;
                
              }
            }
          },
          xaxis: {
            categories: ['2021', '2022', '2023','2024'],
            title: {
              text: 'Year'
            }
          },
          yaxis: {
            title: {
              text: '%'
            },
            gridLines: {
              drawBorder: false,
          },
            min: 0,
            max: 300,
            //forceNiceScale: true,
          },
      
          legend: {
            enabled:true,
            position: 'top',
            horizontalAlign: 'right',
            floating: true,
            offsetY: -25,
            offsetX: -5
          }
          
          }
        
     
      
      
        });

        



  const [ejemploChart3, setejemploChart3] = useState({
    name: "",
    color: "#2271b3",
    data: [],
  })
  
  const [ejemploOptionChart3, setEjemploOptionColumnChart3] = useState({
    chart: {
      type: "area",
      foreColor: "#adb0bb",
      toolbar: {
        show: false,
      },
      height: 60,
      sparkline: {
        enabled: true,
      },
      group: "sparklines",
    },
    stroke: {
      width: 1,
    },
    fill: {
      colors: "blue",
      type: "solid",
      opacity: 0.01,
    },
    markers: {
      size: 0,
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (value) => value.toFixed(2),
      },
    },
    xaxis: {},
  });

  


  const [ejemploChartMargen, setejemploChartMargen] = useState({
    name: "",
    color: "#87CEEB",
    data: [],
  })
  
  const [ejemploOptionChartMargen, setEjemploOptionColumnChartMargen] = useState({
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
      
        dataLabels: {
          position: 'top', // top, center, bottom
        },
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "30%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: {},
  });

  


  const [accumTotal, setAccumTotal] = useState({
    name: "",
    color: "#20603d",
    data: [],
  });
  const [accumTotalChart, setAccumTotalChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });

  const [optionChart1indice, setOptionChart1indice] = useState({
    name: "",
    color: "#20603d",
    data: [],
  });
  const [optionChart1, setOptionChart1] = useState({
    chart: {
      type: "area",
      foreColor: "#20603d",
      toolbar: {
        show: false,
      },
      height: 60,
      sparkline: {
        enabled: true,
      },
      group: "sparklines",
    },
    stroke: {
      width: 1,
    },
    fill: {
      colors: "blue",
      type: "solid",
      opacity: 0.01,
    },
    markers: {
      size: 0,
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (value) => value.toFixed(2),
      },
    },
    xaxis: {},
  });
  const [optionChart2, setOptionChart2] = useState({
    chart: {
      type: "area",
      foreColor: "#adb0bb",
      toolbar: {
        show: false,
      },
      height: 60,
      sparkline: {
        enabled: true,
      },
      group: "sparklines",
    },
    stroke: {
      width: 1,
    },
    fill: {
      colors: "blue",
      type: "solid",
      opacity: 0.01,
    },
    markers: {
      size: 0,
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (value) => value.toFixed(2),
      },
    },
    xaxis: {},
  });

  const [ejemploOptionTortaChart1, setEjemploTortaOptionChart] = useState({
        
    series: [],
    options: {
      chart: {
        width: 150,
        type: 'donut',
        color:'#252850'
      },
      colors: ['#252850', '#87CEEB'],
      tooltip: {
        fillSeriesColor: true,
      },
      total: {
        show: true
    },
      labels: ['utilidades','perdidas'],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'center'
          }
        }
      }]
    }
  })

const [ejemploRadial, setEjemploRadial] = useState({
        
  series: [90],
  options: {
  chart: {
    height: 350,
    type: 'radialBar',
    
},
title: {
  text: 'Crecimiento',
  //offsetX: 110
},
labels: ['2024'],
plotOptions: {
        radialBar: {
          hollow: {
            size: "70%",
          },
          total:{
            show: true,
          },
          value:{
            show: true,
          },
          dataLabels:{
            value:{
              show: true,
            },
          }
        },
      },
    }
  })




  const [ejemploRadial2, setEjemploRadial2] = useState({
        
    series: [90],
    options: {
    chart: {
      height: 350,
      type: 'radialBar',
  },
  title: {
    text: 'crecimiento',
    //offsetX: 110
  },
  labels: ['2024'],
  plotOptions: {
          radialBar: {
            hollow: {
              size: "70%",
            },
            total:{
              show: true,
            },
            value:{
              show: true,
            },
            dataLabels:{
              value:{
                show: true,
              },
            }
          },
        },
      }
    })







  const [optionChart, setOptionChart] = useState({
    chart: {
      type: "area",
      foreColor: "#adb0bb",
      toolbar: {
        show: false,
      },
      height: 60,
      sparkline: {
        enabled: true,
      },
      group: "sparklines",
    },
    stroke: {
      width: 1,
    },
    fill: {
      colors: "blue",
      type: "solid",
      opacity: 0.01,
    },
    markers: {
      size: 0,
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (value) => value.toFixed(2),
      },
    },
    xaxis: {},
  });

  const [optionColumnChartPrueba, setOptionColumnChartPrueba] = useState({
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "80%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: {},
  });

  const [chartRoaRoe, setChartRoaRoe] = useState({})

  const [chartCrecimiento, setChartCrecimiento] = useState({
    series: [],
    options: {
      chart: {
        height: 350,
        type: 'line',
        toolbar: {
          show: false,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
      },
    },
      stroke: {
        width: [0, 4]
      },
      grid: {
        show:false,
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        },
      },
      responsive: [
        {
          breakpoint: 1000,
          options: {
            plotOptions: {
              bar: {
                horizontal: false
              }
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ],
      markers: {
        size: 1
      },
      title: {
        text: 'Evolución ingresos'
      },
      dataLabels: {
        enabled: false,
        enabledOnSeries: [1],
        formatter: function(val, opt) {
          return val+"%"
      },
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: [{
          formatter: function (y) {
            if(typeof y !== "undefined") {
              return  y.toFixed(0) + "$";
            }
            return y;
            
          }
        }, {
          formatter: function (y) {
            if(typeof y !== "undefined") {
              return  y.toFixed(2) + "%";
            }
            return y;
            
          }
        }]
        
      },
      labels: [],
      yaxis: [{
        title: {
          text: 'Ventas',
        },
      
      }, {
        opposite: true,
        title: {
          text: 'Crecimiento'
        }
      }]
      }
    })




    const [chartGastosAdm, setChartGastosAdm] = useState({
      series: [],
      options: {
        chart: {
          height: 350,
          stacked: true,
          color:'#e7e7e7',
          type: 'line',
        },
        dataLabels: {
          enabled: false,
          enabledOnSeries: [3],
        },
        stroke: {
          width: [1, 1, 1,2]
        },
        title: {
          text: 'Gastos adm',
          align: 'left',
          offsetX: 110
        },
        xaxis: {
          categories: [2009, 2010, 2011, 2012],
        },
        yaxis: [
          {
            seriesName: 'Income',
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#008FFB'
            },
            labels: {
              style: {
                colors: '#008FFB',
              }
            },
            title: {
              text: "Income (thousand crores)",
              style: {
                color: '#008FFB',
              }
            },
            tooltip: {
              enabled: true
            },
            min: 0,
            max: 3000000000

          },
          {
            seriesName: 'Cashflow',
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#00E396'
            },
            labels: {
              style: {
                colors: '#00E396',
              }
            },
            title: {
              text: "Operating Cashflow (thousand crores)",
              style: {
                color: '#00E396',
              }
            },
          },
          {
            seriesName: 'Revenue',
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#FEB019'
            },
            labels: {
              style: {
                colors: '#FEB019',
              },
            },
            title: {
              text: "Revenue (thousand crores)",
              style: {
                color: '#FEB019',
              }
            }
          },
        ],
        tooltip: {
          fixed: {
            enabled: true,
            position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60
          },
        },
        legend: {
          horizontalAlign: 'left',
          offsetX: 40
        }
        }
      })



  const [dailyReturnC, setDailyReturnC] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [returnOnWinnersTotal, setReturnOnWinnersTotal] = useState(0);
  const [returnOnWinnersChart, setReturnOnWinnersChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [returnOnLosersTotal, setReturnOnLosersTotal] = useState(0);
  const [returnOnLosersChart, setReturnOnLosersChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [returnLongTotal, setReturnLongTotal] = useState(0);
  const [returnLongChart, setReturnLongChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [returnShortTotal, setReturnShortTotal] = useState(0);
  const [returnShortChart, setReturnShortChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [biggestProfitT, setBiggestProfitT] = useState(0);
  const [biggestLoseT, setBiggestLoseT] = useState(0);
  const [winLoseRatio, setWinLoseRatio] = useState(1);
  const [closedTradesTotal, setClosedTradesTotal] = useState(0);
  const [closedTradesChart, setClosedTradesChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [openTradesTotal, setOpenTradesTotal] = useState(0);
  const [openTradesChart, setOpenTradesChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [allTradesTotal, setAllTradesTotal] = useState(0);
  const [allTradesChart, setAllTradesChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [avgNumTrades, setAvgNumTrades] = useState(0);
  const [totalWin, setTotalWin] = useState(0);
  const [totalLoss, setTotalLoss] = useState(0);
  const [totalWinChart, setTotalWinChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [totalLossChart, setTotalLossChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [beTotal, setBeTotal] = useState(0);
  const [totalBeChart, setTotalBeChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [openPercent, setOpenPercent] = useState(0);
  const [accumReturnPercentTotal, setAccumReturnPercentTotal] = useState(0);
  const [accumReturnPercentSeries, setAccumReturnPercentSeries] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [biggestPercentProfit, setBiggestPercentProfit] = useState(0);
  const [biggestPercentLose, setBiggestPercentLose] = useState(0);
  const [percentProfitsChart, setPercentProfitsChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [percentLosesChart, setPercentLosesChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [totalReturnNet, setTotalReturnNet] = useState(0);
  
  const [totalReturnNetChart, setTotalReturnNetChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });



  useEffect(() => {
   
    (async () => {
     
      setEstadoData(true);
      setIsLoading(true);
      dispatch(setReportsLoading());
      //7loading=true
      //alert("la var es "+loading)
      await axios
        .post("/api/get-reports_effi-inventory", {
          userId,
          filters
        }
       
      
      
      )
        .then(
          (res) => {

          const {
        
            diccionario_productos,
            dict_vendedores,
            dict_devoluciones,
            dict_ventas_por_articulos
          } = res.data;
        setProductos(diccionario_productos)
        setVendedores(dict_vendedores)
        setIsLoading(false)
const productos = Object.keys(diccionario_productos);
const unidades = Object.values(diccionario_productos);

const total = unidades.reduce((a, b) => a + b, 0);

const formatoNumero = new Intl.NumberFormat('es', {
  maximumFractionDigits: 1
});

// Altura dinámica
const altura = Math.max(400, productos.length * 4);
        setChartDataProductos({
  ...ChartDataProductos,

  series: [
    {
      name: "Unidades",
      data: unidades
    }
  ],

  options: {
    chart: {
       type: 'bar',
      height: 600,

      // Zoom
      zoom: {
        enabled: true,
        type: 'xy',
        autoScaleYaxis: true
      },

      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true
        }
    }
  },

    plotOptions: {
      bar: {
        horizontal: true, // 🔥 clave
        borderRadius: 4,
        barHeight: '80%'
      }
    },

    xaxis: {
      categories: productos
    },

    title: {
      text: 'Unidades por producto'
    },

    dataLabels: {
      enabled: true,
      formatter: (val) =>
        new Intl.NumberFormat('es', {
          //notation: 'compact',
          maximumFractionDigits: 1
        }).format(val)
    },

    tooltip: {
      y: {
        formatter: function (value) {
          //alert(value)
          const series = Object.values(diccionario_productos);
          const total = series.reduce((a, b) => a + b, 0);
          const porcentaje = total === 0 ? 0 : (value / total) * 100;

          return `${new Intl.NumberFormat('es', {
            //notation: 'compact',
            maximumFractionDigits: 1
          }).format(value)} unidades (${porcentaje.toFixed(1)}%)`;
        }
      }
    },

    legend: {
      show: false
    }
  }
});

const categorias = dict_vendedores.map(
  x => `${x.Vendedor} - ${x.Centro_de_costos}`
);

const ventas = dict_vendedores.map(
  x => Number(x.total_ventas)
);

setChartDataVendedores({
  series: [{
    name: "Ventas",
    data: ventas
  }],
  options: {
    chart: {
      type: "bar"
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 4
      }
    },
    xaxis: {
      categories: categorias
    },
      dataLabels: {
      enabled: true,
      formatter: (value) => formatoCOP.format(value)
    },

 

   tooltip: {
      custom: function({ series, seriesIndex, dataPointIndex }) {

        const item = dict_vendedores[dataPointIndex];

        return `
          <div style="padding: 10px;">
            <strong>${item.Vendedor}</strong>
            <br>
            Centro: ${item.Centro_de_costos}
            <br>
            Ventas centro: 
            <strong>${formatoCOP.format(Number(item.total_ventas))}</strong>
            <br>
            <hr style="margin: 6px 0;">
            Total vendedor:
            <strong>${formatoCOP.format(Number(item.total_vendedor))}</strong>
          </div>
        `;
      }
    },
    title: {
      text: "Ventas por centro de costos"
    }
  }
});


setChartDataCentroCostos({
  series: [
    {
      name: "Ventas",
      data: dict_devoluciones.map(x => Number(x.total_ventas))
    },
    {
      name: "Devoluciones",
      data: dict_devoluciones.map(x => Number(x.total_devoluciones))
    },
    {
      name: "Ventas netas",
      data: dict_devoluciones.map(x => Number(x.ventas_netas))
    }
  ],

  options: {
    chart: {
      type: "bar"
    },

    xaxis: {
      categories: dict_devoluciones.map(x => x.Centro_de_costos)
    },

    dataLabels: {
      enabled: true,
      formatter: (value) => formatoCOP.format(value)
    },

    yaxis: {
      labels: {
        formatter: (value) => formatoCOP.format(value)
      }
    },

    tooltip: {
      y: {
        formatter: (value) => formatoCOP.format(value)
      }
    },
      title: {
      text: "Ventas con devoluciones"
    }
  }
});


setChartDataVentasPorResponsable({
  series: [
    {
      name: "Cantidad ventas",
      data: dict_ventas_por_articulos.map(x => Number(x.total_ventas))
    }
  ],

  options: {
    chart: {
      type: "bar"
    },

    xaxis: {
      categories: dict_ventas_por_articulos.map(x =>  `${x.responsable}- ${x.categoría}`)
    },

    dataLabels: {
      enabled: true,
      formatter: (value) =>  Number(value).toLocaleString("es-CO")
    },

    yaxis: {
      labels: {
        formatter: (value) => formatoCOP.format(value)
      }
    },

    tooltip: {
      y: {
        formatter: (value) => `${Number(value).toLocaleString("es-CO")} unidades`
      }
    },
      title: {
      text: "Cantidad ventas por responsable y categoría"
    }
  }
});


         })
        .catch((err) => console.log("esto es "+err));
    //  setIsLoading(false);
    })();
  }, [selected, filters]);


if(isLoading){

return  ( <Stack width="100%" justifyContent="center" alignItems="center">
     
<Spinner/>
<Typography variant="h5" sx={{ color: '#0094b6' }}>Please wait</Typography>
</Stack>)

  }
else{
  /*
  if(EstadoData){
    enqueueSnackbar("No data to display here", {
      variant: "warning",
    });
      } */
  if(tabValue==0){
  return (

    <Stack>
      {/*
      {isLoading? (
        <Stack width="100%" justifyContent="center" alignItems="center">
          <Spinner /> */}

{Object.keys(Vendedores).length==0? (
    <Fade in={true} timeout={3600}>
    <Paper sx={{ width: "100%", mb: 2 }}>
      <Stack py={10} alignItems="center" color="text.disabled">
        <TextSnippetIcon sx={{ fontSize: 120 }} />
        <Typography variant="h4">No data to display in effi</Typography>
      </Stack>
    </Paper>
  </Fade>
    ):(
 <Stack>
    <Grid container spacing={2}>
  


 <Grid item xs={12} md={6}>
    <Paper sx={{ p: 2 }}>
      <Chart
        options={ChartDataVendedores.options}
        series={ChartDataVendedores.series}
        type="bar"
        width="100%"
        height={450}
      />
    </Paper>
  </Grid>


  <Grid item xs={12} md={6}>
    <Paper sx={{ p: 2 }}>
      <Chart
        options={ChartDataCentroCostos.options}
        series={ChartDataCentroCostos.series}
        type="bar"
        width="100%"
        height={450}
      />
    </Paper>
  </Grid>

<Grid item xs={12} md={60}>
    <Paper sx={{ p: 2 }}>
      <Chart
        options={ChartDataVentasPorResponsable.options}
        series={ChartDataVentasPorResponsable.series}
        type="bar"
        width="100%"
        height={450}
      />
    </Paper>
  </Grid> 
 

  </Grid>
</Stack>
      )
      

  }

    </Stack>

  )}

 if(tabValue==1){
  return (
<Stack>
<Grid container spacing={2}>

<Grid item xs={12} md={6}>
  <Paper
    sx={{
      p: 2,
      height: 500,
      overflowY: 'auto',
      overflowX: 'hidden'
    }}
  >
    <Chart
      options={ChartDataProductos.options}
      series={ChartDataProductos.series}
      type="bar"
      width="100%"
      height={Math.max(
        450,
         Object.keys(Productos).length * 40
      )}
    />
  </Paper>
</Grid>


</Grid>



</Stack>


  )
 }



}}